/**
 * Venda efetiva do período (#6421, pedido da Talita Bastos): termo ASSINADO dentro do período
 * e já APROVADO na análise cadastral.
 *
 * Por que existe: o "Termos Aprovados" do Dashboard de Negociações conta pela data da
 * aprovação, então inclui termo assinado no mês anterior; e "Termos Reprovados" idem. A
 * gerente tirava aprovados e reprovados dos assinados para chegar no "vendido no mês", e a
 * conta não fechava. Aqui é sempre a turma assinada no período — o número só cresce enquanto
 * as análises dessa turma vão sendo concluídas.
 *
 * O status basta como prova da aprovação: `termo_aprovado` só é gravado ao finalizar a
 * análise, e não muda depois (perdida/reprovada sai dele). Conferido em 26/10/2026: todas as
 * negociações em `termo_aprovado` com data de assinatura têm decisão "Aprovado" ou
 * "Aprovado com Ressalvas".
 *
 * Usada no Dashboard de Negociações do CRM e na tela inicial — mudar aqui muda nos dois.
 */
export interface LinhaVendaEfetiva {
  status?: string | null;
  data_assinatura_termo?: string | null;
}

export const ehVendaEfetiva = (
  linha: LinhaVendaEfetiva,
  dentroDoPeriodo: (iso: string | null) => boolean,
): boolean => linha.status === 'termo_aprovado' && dentroDoPeriodo(linha.data_assinatura_termo ?? null);
